import { Chain } from 'wagmi/chains';

// Define Sonic Blaze testnet
export const sonicBlaze = {
  id: 57054,
  name: 'Sonic Blaze Testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Sonic',
    symbol: 'SONIC',
  },
  rpcUrls: {
    default: { http: ['https://rpc.blaze.soniclabs.com'] },
    public: { http: ['https://rpc.blaze.soniclabs.com'] },
  },
  blockExplorers: {
    default: { name: 'Sonic Explorer', url: 'https://explorer.blaze.soniclabs.com' },
  },
  testnet: true,
} as const satisfies Chain;